import { ReactNode } from "react";
import { useGlobalContext } from "../../utils/GlobalContext";
import { ThemeContextProvider } from "../providers/ThemeContextProvider";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { NetflixAdsLogo } from "./NetflixAdsLogo";
import { useContent } from "../../hooks/useContent";
import { GetCookieSettings } from "../../queries/getCookieSettings";
import cx from "classnames";
import { readFragment } from "gql.tada";
import { LinkFragment } from "../../queries/fragments/LinkFragment";
import { Link } from "./core/Link";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const PageContainer = ({ children }: { children: ReactNode }) => {
  const {
    isRegionLocked,
    localeSettings: { lineBreaksAllowed },
  } = useGlobalContext();
  const [response] = useContent({ query: GetCookieSettings });

  const cookieSettings =
    response.data?.cookieFooterCollection?.items[0] ?? null;

  const link = cookieSettings?.termsAndConditions
    ? readFragment(LinkFragment, cookieSettings.termsAndConditions)
    : undefined;

  return (
    <div
      className={cx(
        "min-h-screen flex flex-col",
        // This is for languages which cannot have lines break on words
        !lineBreaksAllowed && "break-keep"
      )}
    >
      {!isRegionLocked && <Header />}
      <LanguageSwitcher />
      {isRegionLocked && (
        <div className="sticky top-0 left-0 container-base py-3">
          <ThemeContextProvider
            className="flex justify-center items-center w-28 h-10"
            theme={{ palette: "red", foreground: "true", background: "dark" }}
          >
            <NetflixAdsLogo
              className="text-palette-current-foreground w-full"
              secondarySectionProps={{
                className: "text-brand-cream",
              }}
            />
          </ThemeContextProvider>
        </div>
      )}
      <main className="grow">{children}</main>
      {!isRegionLocked && <Footer />}
      {isRegionLocked && cookieSettings && (
        <div className="flex right-0 justify-end container-base py-3">
          {link && (
            <Link
              link={link}
              className="text-body-regular dsk:text-body-small inline-flex mr-5"
            >
              {link?.text}
            </Link>
          )}

          <button
            className="appearance-none text-body-regular dsk:text-body-small"
            onClick={() => {
              // @ts-expect-error We've added this in an initializing script
              window.Optanon?.ToggleInfoDisplay?.();
            }}
          >
            {cookieSettings?.cookiesText}
          </button>
        </div>
      )}
    </div>
  );
};
